jQuery(document).ready(function () {
    jQuery('.wm-rangeCarousel__carousel').each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            prevArrow: jQuery(this).siblings().find('.wm-rangeCarousel__arrow.-prev'),
            nextArrow: jQuery(this).siblings().find('.wm-rangeCarousel__arrow.-next'),
            infinite: false,
            fade: true
        });
    });
});
